module.exports = __webpack_public_path__ + "assets/img/control.8d594f0c.png";